import { fetchWithAuth } from "../../config/axios";

type RequestInitExtended = RequestInit & {
    params?: Record<string, number | Date | string>;
};

/** all credentials traffic goes through choripan under /credentials */
export async function fetchFromCredentials<T>(
    path: string,
    init?: RequestInitExtended,
): Promise<T> {
    const response = await fetchWithAuth.request({
        url: `/credentials${path}`,
        method: (init?.method || "GET") as any,
        data: init?.body ? JSON.parse(init.body as string) : undefined,
        headers: {
            "Content-Type": "application/json",
            ...(init?.headers as Record<string, string>),
        },
        // add params support here if we ever need it
    });

    return response.data as T;
}
